export default __webpack_public_path__ + "static/media/khotcoin.609a5f06.png";